export default {
    permissionCode: (state) => state.permissionCode,
};
